import { SingletonRedirect } from "@/components/SingletonRedirect";

export function BrandingList() {
  return <SingletonRedirect resource="branding" />;
}
